import './faq.scss';

import React from 'react';

import { PortableText } from '../portableText';

export function FaqItem({ faq, faqClickHandler }) {
	return (
		<div
			className='faq-item py05'
			onClick={(e) => faqClickHandler(e.currentTarget)}
			onKeyDown={(e) => faqClickHandler(e.currentTarget)}
			tabIndex={0}
			role='button'
		>
			<div className='faq-question f jcb aic'>
				<p className='mr1 pr1' style={{ fontWeight: 400 }}>
					{faq.question}
				</p>
				<img
					src='/menu-arrow.inline.svg'
					width='12'
					className='faq-arrow up'
				/>
			</div>
			<div className='faq-answer'>
				<PortableText className='mt0 cdgr' blocks={faq._rawAnswer} />
			</div>
		</div>
	);
}
